import { render, staticRenderFns } from "./ProducersTable.vue?vue&type=template&id=4c06e935&scoped=true&"
import script from "./ProducersTable.vue?vue&type=script&lang=js&"
export * from "./ProducersTable.vue?vue&type=script&lang=js&"
import style0 from "./ProducersTable.vue?vue&type=style&index=0&id=4c06e935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06e935",
  null
  
)

export default component.exports